import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CbjButtonComponent } from './cbj-button.component';
import { RouterModule } from '@angular/router';
import { CbjRippleModule } from '../ripple/index';
export class CbjButtonModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    RouterModule,
    CbjRippleModule
  ],
  declarations: [
    CbjButtonComponent
  ],
  exports: [
    CbjButtonComponent
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CbjButtonModule_tsickle_Closure_declarations() {
/** @type {?} */
CbjButtonModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjButtonModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
